if (!customElements.get('custom-drawer')) {
  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
    }

    toggle() {
      this.classList.toggle('menu-opening');
    }

    connectedCallback() {
      Array.from(this.children).forEach((child) => {
        if (child.classList.contains('header-drawer__link')) this.opener = child;
      });

      if (!this.opener) return;

      this.opener.addEventListener('click', (e) => {
        this.toggle();
      });
    }
  }
  customElements.define('custom-drawer', CustomDrawer);
}
